export default __webpack_public_path__ + "static/media/aws_logo.84d24e4e.png";